import { render } from "./Loader.vue?vue&type=template&id=3c62c988&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=3c62c988&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c62c988"]])

export default __exports__